import { Card, CardActions, CardContent, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useCallback, useState } from 'react';
import { OrderCardExpandButton } from './OrderCardExpandButton';

export default function OrderCard({
  hasExpandedSection = false,
  renderExpandSection,
  ActionButtons,
  children,
  ExpandIcon = <ExpandMoreIcon />,
}) {
  const [expand, setExpand] = useState(false);

  const handleExpand = useCallback(() => {
    setExpand(!expand);
  }, [expand]);

  return (
    <Card sx={{ mb: 1.5, borderRadius: 3, position: 'relative', boxShadow: 3 }}>
      <CardContent>{children}</CardContent>

      {hasExpandedSection && (
        <>
          <Collapse in={expand} timeout="auto" unmountOnExit>
            <CardContent sx={{ pt: 0 }}>{renderExpandSection()}</CardContent>
          </Collapse>

          <CardActions sx={{ justifyContent: 'center' }}>
            <OrderCardExpandButton
              expand={expand}
              onClick={handleExpand}
              icon={ExpandIcon}
            />
          </CardActions>
        </>
      )}

      {ActionButtons && (
        <CardActions sx={{ px: 2, pb: 2 }}>{ActionButtons}</CardActions>
      )}
    </Card>
  );
}
